import { render, staticRenderFns } from "./Isaac.vue?vue&type=template&id=655f4573&scoped=true&"
import script from "./Isaac.vue?vue&type=script&lang=js&"
export * from "./Isaac.vue?vue&type=script&lang=js&"
import style0 from "./Isaac.vue?vue&type=style&index=0&id=655f4573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655f4573",
  null
  
)

export default component.exports